export const mpStates = [{ value: 'MP', label: 'MP' }]
